var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPsbank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PSBank",
    clipPath: "url(#clip0_342:15910)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 444707"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.335 0L6.66504 6.66501H13.335V20L20.0001 13.35V0H13.335Z",
    fill: "currentColor000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.66501 20L13.335 13.335H6.66501V0L0 6.65001V20H6.66501Z",
    fill: "currentColor000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_342:15910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsbank);
export default __webpack_public_path__ + "static/media/psbank.62c82f80a450e233a240dee00b65fa43.svg";
export { ForwardRef as ReactComponent };